import { render, staticRenderFns } from "./UnassociateClinic.vue?vue&type=template&id=36fa2d54&scoped=true&"
import script from "./UnassociateClinic.vue?vue&type=script&lang=js&"
export * from "./UnassociateClinic.vue?vue&type=script&lang=js&"
import style0 from "./UnassociateClinic.vue?vue&type=style&index=0&id=36fa2d54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa2d54",
  null
  
)

export default component.exports